package org.braunequip.web.components.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.braunequip.web.styles.LoginInputStyle
import org.braunequip.web.styles.noBorder
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Res
import org.braunequip.web.util.Theme
import org.braunequip.web.util.checkUserPin
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement

@Composable
fun PortalPinForm(
    content: @Composable () -> Unit
) {
    val scope = rememberCoroutineScope()

    var errorText by remember { mutableStateOf(" ") }
    var userHasAccess by remember { mutableStateOf(false) }

    if (userHasAccess) {
        content()
    } else {
        //Represents whole screen
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            Column(
                modifier = Modifier
                    .padding(leftRight = 50.px, top = 80.px, bottom = 24.px)
                    .backgroundColor(Theme.DarkGray.rgb),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Image(
                    modifier = Modifier
                        .margin(bottom = 50.px)
                        .width(100.px),
                    src = Res.Image.logo,
                    description = "Logo Image"
                )

                //Pin
                Input(
                    type = InputType.Text,
                    attrs = LoginInputStyle.toModifier()
                        .id(InputIDs.EmployeePin.portalPin)
                        .margin(bottom = 12.px)
                        .width(350.px)
                        .height(54.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Colors.White)
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(14.px)
                        .outline(
                            width = 0.px,
                            style = LineStyle.None,
                            color = Colors.Transparent
                        )
                        .toAttrs {
                            attr("placeholder", "PIN")
                        }
                )

                //Sign In
                Button(
                    attrs = Modifier
                        .margin(bottom = 24.px)
                        .width(350.px)
                        .height(54.px)
                        .backgroundColor(Theme.Primary.rgb)
                        .color(Colors.White)
                        .fontFamily(FONT_FAMILY)
                        .fontWeight(FontWeight.Medium)
                        .fontSize(14.px)
                        .borderRadius(r = 4.px)
                        .noBorder()
                        .cursor(Cursor.Pointer)
                        .onClick {
                            errorText = " "
                            val pin = (document.getElementById(InputIDs.EmployeePin.portalPin) as HTMLInputElement).value
                            if (pin.isNotEmpty() && pin.isNotBlank()) {
                                scope.launch {
                                    userHasAccess = checkUserPin(pin)
                                    if (!userHasAccess) {
                                        errorText = "Please enter valid PIN"
                                    }
                                }
                            } else {
                                errorText = "Please Enter PIN"
                            }
                        }
                        .toAttrs()
                ) {
                    SpanText(text = "Submit PIN")
                }

                SpanText(
                    modifier = Modifier
                        .width(350.px)
                        .fontFamily(FONT_FAMILY)
                        .color(Colors.Red)
                        .textAlign(TextAlign.Center),
                    text = errorText
                )

            }
        }
    }
}